import axios from '@/utils/ajax/index'; // 倒入 api
import fileExport from '@/utils/fileExport/index'; // 导出文件 api
// 会员列表
export const getPatients = (data) => {
  return axios({
    url: '/chain/member/getPatients',
    method: 'POST',
    data,
  });
};


/* 查询连锁诊所会员以及每月增长数量 */
export const getPatientsSum = (data) => {
  return axios({
    url: '/chain/member/getPatientsSum',
    method: 'POST',
    data,
  });
};

// 查询会员卡充值记录
export const getChargeRecord = (data) => {
  return axios({
    url: '/chain/member/chargeRecord',
    method: 'POST',
    data,
  });
};

// 短信发送记录
export const getSmsRecord = (data) => {
  return axios({
    url: '/chain/member/smsRecord',
    method: 'POST',
    data,
  });
};

// 短信发送记录
export const getCouponRecord = (data) => {
  return axios({
    url: '/chain/member/couponRecord',
    method: 'POST',
    data,
  });
};

// 获取VIP卡信息数组
export const getAllVipCards = (params) => {
  return axios({
    url: '/chain/member/allVipCards',
    method: 'GET',
    params,
  });
};

// 根据卡查询所办会员列表
export const getVipPatients = (data) => {
  return axios({
    url: '/chain/member/card/listPatients',
    method: 'POST',
    data,
  });
};

// 修改会员卡
export const updateVipCard = (data) => {
  return axios({
    url: '/chain/member/updateVipCard',
    method: 'PUT',
    data,
  });
};

// 创建会员卡
export const createVipCard = (data) => {
  return axios({
    url: '/chain/member/vipCard',
    method: 'POST',
    data,
  });
};

// 逻辑删除VIP卡
export const delVipCard = (params) => {
  return axios({
    url: `/chain/member/${params.id}`,
    method: 'DELETE',
  });
};

// 会员卡详情
export const getVipCardsDetail = (params) => {
  return axios({
    url: `/chain/member/vipCard/${params.id}`,
    method: 'GET',
  });
};

// 会员数据下载
export const exportMember = (params) => {
  const path = '/chain/member/exportPatientInfo';
  fileExport(path, params);
};


// 导出会员列表
// export const

export default {
  getPatients,
  getPatientsSum,
  getChargeRecord,
  getSmsRecord,
  getCouponRecord,
  getAllVipCards,
  getVipPatients,
  updateVipCard,
  createVipCard,
  getVipCardsDetail,
  delVipCard,
  exportMember,
};
